import opportunityInfoService from '../services/oneButtonServices/opportunityInfoService';

import { useOneButtonStore } from '../store/oneButtonStore';

import {

    applyTitleSyncToOpportunityCustomers,

    mergeOpportunityCustomersAfterTitleSync,

    preserveTitleSyncFlagsAfterReload,

    type TitleSyncCustomerRef,

} from './titleContactStatus';



/** Apply optimistic ON TITLE flags, reload opportunity customers, and refresh open contacts UI. */

export async function refreshOpportunityAfterTitleSync(

    syncedContacts: TitleSyncCustomerRef[],

): Promise<void> {

    const store = useOneButtonStore.getState();

    let opp = store.opportunityDetails;

    let optimisticOpportunity: Record<string, unknown> | null = null;



    if (opp && syncedContacts.length > 0) {

        const patched = applyTitleSyncToOpportunityCustomers(opp, syncedContacts);

        if (patched) {

            optimisticOpportunity = patched;

            store.setOpportunityDetails(patched);

            opp = patched;

        }

    }



    const salesForceId = opp?.SalesForce_Id ?? opp?.salesForce_Id;

    if (salesForceId) {

        try {

            const updatedDetails = await opportunityInfoService.getOpportunityDetail(salesForceId);

            const actualData = updatedDetails?.data ?? updatedDetails;

            if (actualData) {

                const mergedFromSync =

                    mergeOpportunityCustomersAfterTitleSync(actualData, syncedContacts) ?? actualData;

                const merged =

                    optimisticOpportunity != null

                        ? preserveTitleSyncFlagsAfterReload(optimisticOpportunity, mergedFromSync) ??

                          mergedFromSync

                        : mergedFromSync;

                store.setOpportunityDetails(merged);

            }

        } catch (err) {

            console.error('Failed to refresh opportunity after title sync', err);

        }

    }



    store.notifyContactsTitleSynced();

}


